import { WarningImage } from '@approvalmax/ui';
import { Button, Grid, Link, Popup, Text } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { memo, useCallback } from 'react';

import { messages } from './ConnectionCanceledPopup.messages';
import { connectionCanceledPopupOpenState } from './ConnectionCanceledPopup.states';

export const ConnectionCanceledPopup = memo(() => {
    const [open, toggleOpen] = useAtom(connectionCanceledPopupOpenState);

    const handleClose = useCallback(() => {
        toggleOpen(false);
    }, [toggleOpen]);

    return (
        <Popup className='fs-exclude' size='xsmall' open={open} onToggle={toggleOpen}>
            <Popup.Body spacing='32'>
                <Grid gap={24} justifyItems='center'>
                    <WarningImage />

                    <Text font='headline' fontSize='small' fontWeight='medium' textAlign='center'>
                        {messages.unableToEstablish}
                    </Text>

                    <Text font='body' fontSize='medium' textAlign='center'>
                        {messages.thereWasAnIssue}
                    </Text>

                    <Link
                        external
                        font='label'
                        fontSize='medium'
                        textAlign='center'
                        href='https://support.approvalmax.com/portal/en/kb/articles/why-my-bank-account-connection-has-failed'
                    >
                        {messages.learnMore}
                    </Link>

                    <div>
                        <Button color='blue80' size='large' onClick={handleClose}>
                            {messages.close}
                        </Button>
                    </div>
                </Grid>
            </Popup.Body>
        </Popup>
    );
});

ConnectionCanceledPopup.displayName = 'ConnectionCanceledPopup';
